import { createContext } from 'react'

const AttachmentContext = createContext({ attachments: [] })

export default AttachmentContext
